import { createAction, props } from '@ngrx/store';
import { Country } from '../Clubs/clubs.model';
import { Club, Dossier } from './dossier.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier',
    props<{ memberId: number }>()
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier success', 
    props<{ listData: Dossier[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier failure', 
    props<{ error: string }>()
);

//Fetch Club Speific Dossiers
export const fetchSpecificData = createAction(
    '[Data] fetch specific records dossier',
    props<{ clubId: number }>()
);

export const fetchSpecificDataSuccess = createAction(
    '[Data] fetch specific records dossier success', 
    props<{ listData: Dossier[], total: number }>()
);

export const fetchSpecificDataFail = createAction(
    '[Data] fetch specific records dossier failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier success', 
    props<{ singleData: Dossier, dossierData: {countryList: Country[], clubs: Club[]} }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier',
);